import { getModalPortal } from "../../../../../helpers/modal-helper";
import { TActionObject } from "../../../../../types/modal-types";
import styles from "./desktop-menu-modal.module.less";
import * as Dialog from "@radix-ui/react-dialog";

type TDesktopMenuModal = {
  children?: React.ReactNode;
  isOpen: boolean;
  close?: TActionObject;
};

export const DesktopMenuModal = ({ children, isOpen, close }: TDesktopMenuModal) => {
  const onClickOverlay = typeof close?.function === "function" ? close.function : undefined;
  const portal = getModalPortal();

  return (
    <Dialog.Root open={isOpen} modal={false}>
      <Dialog.Portal container={portal}>
        <div className={styles.modalOverlay} onClick={close?.function}></div>
        {/* <Dialog.Overlay className={[styles.modalOverlay].join(" ")} /> */}
      </Dialog.Portal>
      <Dialog.Content onEscapeKeyDown={onClickOverlay} className={[styles.content].join(" ")}>
        <div className={styles.innerContent}>{children}</div>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default DesktopMenuModal;
